import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgDataflow04 } from "@digits-shared/components/SVGIcons/line/Dataflow04.svg"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

export const SvgDepartmentIcon = styled(SvgDataflow04)`
  ${svgPathStyles(colors.secondary)}
`
